import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useStoredItem } from "../../../state/InternalContext";

interface ItemChildrenProps {
    item: string,
}

/***
 * Array source that returns the children of a stored item.
 */
export const ItemChildren = React.memo(function ItemChildren({ item }: ItemChildrenProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const storedItem = useStoredItem(item);

    useEffect(() => {
        setArray(storedItem?.children || []);
    }, [storedItem, setArray]);

    return <></>;
});